import { registerCustomElement } from '../utils.mjs';
import { ArrayInput, ArrayInputItem } from './array.mjs';
import { create } from '../utils.mjs';
import { markdown } from '../markdown.mjs';
import EventManager from '../eventManager.mjs';

class SortEnd extends HTMLElement {
	build() {
		const node = document.createTextNode('End');

		this.classList.add('form-sort-end');
		this.appendChild(node);
	}
}

class SortItem extends ArrayInputItem {
	async build(instructions, value) {
		this.classList.add('sort-item');

		this.setAttribute('type', 'array-item');

		this._label = create(
			this.closest('imt-input-sort')?.parentElement.querySelector('imt-input-sort') === null
				? 'label'
				: 'label.sort-label',
		);
		this._label.setAttribute('for', this._id);
		this.appendChild(this._label);

		// Add textContent after the icon
		// markdown escapes HTML, therefore innerHTML is safe to use
		const labelContent = create('span.label-text-content-sort-item');
		const subtitle = create('span.text-muted.label-text-content-sort-item.ml-1');

		if (this.closest('imt-input-sort')?.querySelectorAll('imt-input-sort-item').length < 1) {
			if (instructions.label) {
				labelContent.innerHTML = markdown(instructions.label);
			} else {
				labelContent.innerText = instructions.name;
			}
		} else {
			this._value = value;
			labelContent.innerText = this._value.title;
			subtitle.innerText = this._value.subtitle ?? '';
		}

		if (this.querySelector('.sort-label') !== null) {
			this._sort = this._label.appendChild(create('div.sort'));
			this._sortText = this._sort.appendChild(create('div.sort-text'));

			const sortIMG = create('div.sort-img');

			sortIMG.style.backgroundColor = this._value.iconBackground;
			this._sortIMG = this._sort.appendChild(sortIMG);

			if (this._value.icon) {
				const icon = document.createElement('img');

				icon.classList.add('sort-icon');
				icon.src = this._value.icon;
				this._sortIcon = this._sortIMG.appendChild(icon);
			}

			this._sortText.appendChild(labelContent);
			labelContent.appendChild(subtitle);
			this.sortLabelID = this._sortText.appendChild(create('div.sort-label-id'));
			this._labelContent = labelContent;

			// Input actions wrapper
			if (this._value.fixed) {
				this._actions = this._label.appendChild(
					create('div.input-actions.input-actions-sort.input-actions-sort-hidden'),
				);
				this.setAttribute('fixed', true);
			} else {
				this._actions = this._label.appendChild(create('div.input-actions.input-actions-sort'));
				this.setAttribute('fixed', false);
			}

			if (this._value.id) {
				const sortInnerText = create('div.label-preview-sort.label-preview.label-id');

				sortInnerText.innerText = this._value.id;
				this.sortLabelID.appendChild(sortInnerText);
			}

			const labelPreviewSort = create('div.label-preview-sort.label-preview');

			labelPreviewSort.innerText = this._value.description;
			this._labelPreview = this.sortLabelID.appendChild(labelPreviewSort);
		}

		this._registerArrayItemControls();
	}

	_registerArrayItemControls() {
		const dragDropBtn = create('div.form-drag-drop.form-sort-drag-drop');
		const arrowDown = create('div.form-arrow-down.form-arrow-hidden');

		dragDropBtn.setAttribute('draggable', true);

		arrowDown.addEventListener('click', (e) => {
			this._swapNodesDownArrow(this, this.parentNode.querySelectorAll('imt-input-sort-item')[this.index + 1]);
			this._manageArrowIcons(this);
			EventManager.dispatch(this.parentElement, 'sorted', { bubbles: true });
		});

		if (this.parentElement.querySelectorAll('imt-input-sort-item').length === 1) {
			const arrowUp = create('div.form-arrow-up.form-arrow-hidden');

			arrowUp.addEventListener('click', (e) => {
				this._swapNodesUpArrow(this, this.index, this.index - 1);
				this._manageArrowIcons(this);
			});
			this._actions.appendChild(arrowUp);
		} else {
			const arrowUp = create('div.form-arrow-up');

			arrowUp.addEventListener('click', (e) => {
				this._swapNodesUpArrow(this, this.index, this.index - 1);
				this._manageArrowIcons(this);
			});
			this._actions.appendChild(arrowUp);
		}

		this._actions.appendChild(arrowDown);
		this._actions.appendChild(dragDropBtn);

		// make previous nodes's arrow down icon visible
		if (
			this.parentElement.querySelectorAll('imt-input-sort-item').length > 1 &&
			this.querySelectorAll('.input-actions-sort-hidden').length === 0
		) {
			const previousElement =
				this.parentElement.querySelectorAll('imt-input-sort-item')[
					this.parentElement.querySelectorAll('imt-input-sort-item').length - 2
				];

			previousElement.querySelector('.form-arrow-down').classList.remove('form-arrow-hidden');
		}
	}

	_swapNodesUpArrow(node, from, to) {
		node.parentNode.insertBefore(
			node.parentNode.querySelectorAll('imt-input-sort-item')[from],
			node.parentNode.querySelectorAll('imt-input-sort-item')[to],
		);
	}

	_swapNodesDownArrow(node1, node2) {
		const afterNode2 = node2.nextElementSibling;
		const parent = node2.parentNode;

		node1.replaceWith(node2);
		parent.insertBefore(node1, afterNode2);
	}

	_manageArrowIcons(draggedElement) {
		const items = this.parentElement.querySelectorAll('imt-input-sort-item');
		const itemsLenght = items.length - this.parentElement.querySelectorAll('.input-actions-sort-hidden').length;

		if (items[0].querySelectorAll('.form-arrow-up').length !== 0) {
			items[0].querySelector('.form-arrow-up').classList.add('form-arrow-hidden');
		}
		if (draggedElement.index !== 0 && draggedElement.querySelectorAll('.form-arrow-hidden').length !== 0) {
			draggedElement.querySelector('.form-arrow-hidden').classList.remove('form-arrow-hidden');
		} else if (draggedElement.index === 0) {
			items[1].querySelector('.form-arrow-up').classList.remove('form-arrow-hidden');
		}

		if (items[itemsLenght - 1].querySelectorAll('.form-arrow-down').length !== 0) {
			items[itemsLenght - 1].querySelector('.form-arrow-down').classList.add('form-arrow-hidden');
			items[itemsLenght - 2].querySelector('.form-arrow-down').classList.remove('form-arrow-hidden');
		}
	}

	get value() {
		return this._value;
	}
}

export class SortInput extends ArrayInput {
	constructor() {
		super();
		this._itemSelector = 'imt-input-sort-item';
		this._removeItemsOnRemove = false;
		this._buttonSelector = 'imt-input-sort-end';
	}

	get hasModeSwitch() {
		return false;
	}

	onDrop(draggedElement) {
		const items = draggedElement.parentElement.querySelectorAll('imt-input-sort-item');
		const itemsLenght =
			items.length - draggedElement.parentElement.querySelectorAll('.input-actions-sort-hidden').length;

		if (draggedElement.parentElement.querySelector('imt-input-sort-item').querySelector('.form-arrow-up') !== null) {
			draggedElement.parentElement
				.querySelector('imt-input-sort-item')
				.querySelector('.form-arrow-up')
				.classList.add('form-arrow-hidden');
		}

		if (draggedElement.index !== 0 && draggedElement.querySelectorAll('.form-arrow-hidden').length !== 0) {
			draggedElement.querySelector('.form-arrow-hidden').classList.remove('form-arrow-hidden');
		} else if (draggedElement.index === 0 && items.length > 1) {
			items[1].querySelector('.form-arrow-up').classList.remove('form-arrow-hidden');
			items[0].querySelector('.form-arrow-up').classList.add('form-arrow-hidden');
			items[0].querySelector('.form-arrow-down').classList.remove('form-arrow-hidden');
		}

		if (items[itemsLenght - 1].querySelectorAll('.form-arrow-down').length !== 0) {
			items[itemsLenght - 1].querySelector('.form-arrow-down').classList.add('form-arrow-hidden');
			items[itemsLenght - 2].querySelector('.form-arrow-down').classList.remove('form-arrow-hidden');
		}

		EventManager.dispatch(this, 'sorted', { bubbles: true });
	}

	validate() {
		// there's nothing to validate as the field is just sorting data
		return true;
	}
}

registerCustomElement('imt-input-sort-end', SortEnd);
registerCustomElement('imt-input-sort-item', SortItem);
registerCustomElement('imt-input-sort', SortInput);
